export default __webpack_public_path__ + "static/media/sht.3eabf860.png";